// extracted by mini-css-extract-plugin
export default {"icons":"GuaranteeCard_icons__A4Klv","greyText":"GuaranteeCard_greyText__P1omS"};